export class WorkflowActionTemplate {
  WorkflowActionID: number = -1;
  WorkflowID: number = -1;
  Seq: number = 0;
  Title: string = '';
  Description: string = '';
  DefaultOwnerUserID?: number | null;
  DefaultOwnerTypeID?: number | null;
  DefaultDueInDays?: number;
  IsMandatory: boolean = false;
  ActionVariationID: number = 1;
  AuditID?: number | null;

  constructor(values: Partial<WorkflowActionTemplate> = {}) {
    Object.assign(this, values);
  }
}
